import { SolType } from '@sol/components';
import { Note, NoteAuthor } from './note.model';

export class NoteType {
  public static readonly author = SolType.ofObject<NoteAuthor>('annotationNotes.noteAuthor', {
    id: SolType.string,
    name: SolType.string,
    kind: SolType.string,
  });

  public static readonly note = SolType.ofObject<Note>('annotationNotes.note', {
    id: SolType.string,
    text: SolType.string,
    author: NoteType.author,
    created: SolType.date,
    edited: SolType.boolean,
    version: SolType.number,
  });
}
